var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"__button",class:_vm.checkClass(),attrs:{"type":_vm.type},on:{"click":function($event){return _vm.clickEvent($event)}}},[_vm._t("icon-before"),_c('span',[_vm._t("default")],2),_vm._t("icon-after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }